<div class="public-layout">
    <app-topbar></app-topbar> <!-- SIEMPRE FUERA del contenido -->
    <div class="layout-content-wrapper">
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-rightmenu></app-rightmenu>
</div>

